type Key = 'trainings-my-requests' | 'trainings-my-trainings-hint' | 'trainings-settings-hint'

export const useGetKeys = () => {
  const getKey = (key: Key) => localStorage.getItem(key)
  const setKey = (key: Key) => localStorage.setItem(key, 'completed')

  return { getKey, setKey }
}
